import './index.scss'
export default ({value, placeholder}: {value?:string, onChange?:void, placeholder?:string})=>{
  return <div className="SimulationInput adm-input">
          <div className="adm-input-element">
            {value?<div className='value'>{value}</div>:<span className='placeholder'>{placeholder}</span>}
          </div>
        </div>
}